import React from "react"
import Seo from '../components/seo'
import Layout from "../containers/layout/layout"
import Header from '../containers/layout/header'
import Footer from '../containers/layout/footer'
import TitleArea from '../containers/contact/title-area'
import BannerArea from '../containers/contact/banner-area'
import FormArea from '../containers/contact/form-area'

const ContactPage = () => (
	<Layout>
		<Seo
			title="Contact"
			description="Dynamic contact form with getform"
			keywords={["contact", "contact form", "get form"]}
		/>
		<Header />
		<div className="main-content">
			<TitleArea />
			<BannerArea />
			<FormArea />
		</div>
		<Footer />
	</Layout>
)

export default ContactPage
